/*!
 * GrandManège
 *
 * Copyright 2022, tix02.be 
 * @author: Xavier Mertens – xav@tix02.be
*/

'use strict';


import gsap from "gsap";
window.gsap = gsap; // made it available anywhere 

import './shared/index';
import './includes/index';
import './behavior/index';

import './components/shows-archive-nav';
import './components/shows-carousel';
import './components/news-list-horizontal';
import './components/mailing-list';
import './components/media-gallery';
import './components/modal';
import './components/accordion';


const evt = new CustomEvent('pageLoad', { 
	detail:{ document: document }, 
});
document.dispatchEvent(evt);